module.exports = __webpack_public_path__ + "static/media/quieromibarrio6.3a837fcb.webp";